import * as React from 'react'
import {ReactElement} from 'react'
import {ErrorProps} from './ResidentHocInputErrorHandling'
import {DisplayItemSelect, DisplayItemSelectWrapper} from '../../../../styledComponents/DisplayItem'
import styled from 'styled-components'
import {Colors} from '../../../../styledComponents/Constants'
import {createErrorHandlingForm, ErrorHandlingFormProps} from '../hoc/createResidentErrorHandlingForm'

interface Props {
    inputProps: React.SelectHTMLAttributes<HTMLSelectElement>
    onChange?: (event: any, checked?: boolean) => void
    options: Option[]
    placeholder?: string
}

export interface Option {
    label: string
    value: string
}

class PPSelectForResident extends React.Component<Props & ErrorHandlingFormProps & ErrorProps> {

    constructor(props: Readonly<Props & ErrorHandlingFormProps & ErrorProps>) {
        super(props)

        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event: React.ChangeEvent<HTMLSelectElement>): void {
        if (this.props.onChange) {
            return this.props.onChange(event)
        }
    }


    render(): ReactElement {
        const {inputProps, options, hasError, placeholder, ...rest} = this.props

        return (
            <AutoHeightSelectWrapper>
                <DisplayItemSelectPlaceHolder
                    {...rest}
                    {...inputProps}
                    onChange={this.handleChange}
                    placeHolderFlag={this.props.inputProps.value === ''}
                    hasError={hasError}
                >
                    {placeholder &&
                        <PlaceHolderOption value={''} disabled={true}>
                            {placeholder}
                        </PlaceHolderOption>
                    }

                    {options.map((option, key) => {
                        return (
                            <DisplayOption key={key} value={option.value}>
                                {option.label}
                            </DisplayOption>
                        )
                    })}
                </DisplayItemSelectPlaceHolder>
            </AutoHeightSelectWrapper>
        )
    }
}

export default createErrorHandlingForm(PPSelectForResident)

// リストの複数行表示に対応するため、displayItemSelectCommonStyle / displayItemInputCommonStyle の height: 50px固定を
// select要素自体（DisplayItemSelectPlaceHolder）と親Wrapper（AutoHeightSelectWrapper）でautoにオーバーライド。min-heightを50pxとする
export const DisplayItemSelectPlaceHolder = styled(DisplayItemSelect)<{ placeHolderFlag: boolean }>`
  color: ${props => props.placeHolderFlag === true ? `${Colors.Placeholder}` : `${Colors.Body}`};
  height: auto;
  min-height: 50px;
  white-space: normal;
  overflow-wrap: anywhere;
  line-break: anywhere;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 35px;
`

const AutoHeightSelectWrapper = styled(DisplayItemSelectWrapper)`
  height: auto;
  min-height: 50px;
`

export const PlaceHolderOption = styled.option`
  display: none;
  color: ${Colors.Placeholder}
`

export const DisplayOption = styled.option`
  color: ${Colors.Body};
`
